import {Schedule} from 'modules/wineshops-list/helpers/schedule';
import {ISchedule} from 'modules/wineshops-list/models';
import {useMemo} from 'react';

export const useShopSchedule = (schedule?: ISchedule[]) => {
    return useMemo(() => {
        if (!schedule) {
            return [];
        }

        const {formattedSchedule} = new Schedule(schedule);
        return formattedSchedule;
    }, [schedule]);
};
